<template>

    <div id="reset-password">

        <template v-if="!reset">

            <h1>Glemt dit kodeord?</h1>
            <p>Send os din email, så sender vi dig en besked med hjælp til at lave et nyt kodeord.</p>

            <form @submit.prevent="submitEmail()">

                <fieldset>
                    <label for="email">Email</label>
                    <input type="email" id="email" v-model="email" required>
                </fieldset>

                <fieldset>
                    <input type="submit" value="Send">
                </fieldset>

            </form>

        </template>

        <template v-if="reset">

            <h1>Vælg et nyt kodeord</h1>

            <form @submit.prevent="submitPassword()">

                <fieldset>
                    <label for="password1">Indtast nyt kodeord</label>
                    <input type="password" id="password1" v-model="password1" required>
                </fieldset>

                <fieldset>
                    <label for="password2">Gentag dit kodeord</label>
                    <input type="password" id="password2" v-model="password2" required>
                </fieldset>

                <fieldset>
                    <input type="submit" value="Send nyt kodeord">
                </fieldset>

            </form>

        </template>
    
    </div>

</template>

<script>

    import axios from '../../utils/Http.js'
    import notify from '../../utils/notify/Notify.js'

    export default {
        data: function() {
            return {
                email: '',
                reset: false,
                password1: null,
                password2: null
            }
        },
        methods: {
            submitEmail: function() {

                axios({
                    method: 'post',
                    url: '/auth/password/reset/',
                    data: {
                        email: this.email
                    }
                })
                .then(res => {
                    notify('Du vil få tilsendt en email, som hjælper dig videre.', 'success')
                    this.$router.push('/signin')
                })
                .catch(err => {
                    notify('Noget gik galt', 'error', err.response.data)
                })

            },
            submitPassword: function() {

                if (this.password1 === this.password2) {
                    axios({
                        method: 'post',
                        url: '/auth/password/reset/confirm/',
                        data: {
                            uid: this.$route.query.uid,
                            token: this.$route.query.token,
                            new_password1: this.password1,
                            new_password2: this.password2
                        }
                    })
                    .then(res => {
                        notify('Du kan nu bruge dit nye kodeord', 'success')
                        this.$router.push('/signin')
                    })
                    .catch(err => {
                        notify('Noget gik galt', 'error', err.response.data)
                    })
                } else {
                    notify('De to kodeord skal være ens', 'error')
                }

            }
        },
        created: function() {

            if (this.$route.query.action === 'password_reset') {
                this.reset = true
            }

        }
    }

</script>

<style>

    #reset-password {
        margin: 1rem;
    }

</style>